"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GarbageCan = void 0;
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function GarbageCan({ size = 20, color = '#3db384' }) {
    return (react_1.default.createElement(react_native_svg_1.default, { width: size, height: size, viewBox: "0 0 15.29 17" },
        react_1.default.createElement(react_native_svg_1.Path, { d: "M.5 2.79h14.29M13.64 2.79l-.57 12a1.72 1.72 0 01-1.71 1.71H3.93a1.72 1.72 0 01-1.72-1.71l-.57-12", fill: "none", stroke: color }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M5.36 2.79V1.64A1.14 1.14 0 016.5.5h2.29a1.14 1.14 0 011.14 1.14v1.15M5.93 7.07v5.14M9.36 7.07v5.14", fill: "none", stroke: color })));
}
exports.GarbageCan = GarbageCan;
